import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Avatar from 'react-toolbox/lib/avatar'
import Chip from 'react-toolbox/lib/chip'
import CSSModules from 'helpers/CSSModulesUtil'
import T from 'i18n-react'
import { PASS_FINAL, PASS_INTER, FAIL, PENDING } from './constants'

import Body from 'components/typography/body2/index'

import styles from './styles.scss'

const StatusChip = ({ text }) => {

  let classname = styles.chipGray

  if ([PASS_FINAL, PASS_INTER].includes(text)) {
    classname = styles.chipGreen
  } else if (text == FAIL) {
    classname = styles.chipRed
  } else if (text == PENDING) {
    classname = styles.chipOrange
  }

  return (
    <Chip className={classname}>
      <Body theme={styles}>{text}</Body>
    </Chip>
  )
}

export default CSSModules(styles)(StatusChip)